/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useEffect, useState } from 'react';
import { makeStyles, createStyles } from '@mui/styles';
import { useHistory } from 'react-router-dom';
import * as API from '../http/api';
import * as FUNC from '../functions/functions';
import * as Components from '../components';
import InfoVirtualCard from './modals/InfoVirtualCard';
import SuccessAssign from './modals/SuccessAssign';
import CardsCompany from './modals/CardsCompany';
import AssignRif from './modals/AssignRif';
import AlboCardCIH from './modals/AlboCardCIH';
import TutukaOperationManual from './modals/TutukaOperationManual';
import PldModalController from "./modals/PldModalController";

import { AfbCustomer, AfbSpace, AlboCard, AccountBlockList, FilterDateMessage, AlboQueryLanguaje, TransactionsLabels, AssignAgreement, LimitsBalance, AdminFormsPLD, AccountStatement, Factor, TaxPayment, ValidateClabe, AfbPreloadWorkers, AfbInvestmentAdmin, SignatureAdmin, QueueManager, GenerateTxInfo, MassExpedientDownload, InsertBQChargeback } from './modals';
import SecondaryMenu from './elements/SecondaryMenu';
import CustomSearchBar from './elements/SearchBar/CustomSearchBar';
import { initDay, endDay, startDate, endDate } from './elements/DateRangePicker';
import { Grid, Box, IconButton, ListItem, Card, Typography } from "@mui/material";
import { ThemeProvider } from '@mui/material/styles';
import MenuIcon from '@mui/icons-material/Menu';
import { openlightbox } from '../util/Functions';
import { ContentStyle, theme } from '../util/TableStyles';
import { searchOptions, widgetDescription } from '../util/DataObject';
import moment from 'moment';
import 'moment/locale/es';

const useStyles = makeStyles((theme) => createStyles({
    searchContent: {
        width: '100%'
    },
    blur: {
        filter: 'blur(4px)'
    }
}));

const Content = (props) => {
    moment.locale('es');
    const classes = useStyles();
    const history = useHistory();
    const [makeOp, setMakeOp] = useState(false);
    const [catalogs, setCatalogs] = useState({
        country: [],
        gender: [],
        states: [],
        occupations: [],
        civilStatus: [],
        status: [],
        banks: [],
        mccs: [],
        cancelation: [],
        cancelationC: [],
        cancelationCS: [],
        cancelationCustomer: [],
        blockC: [],
        blockCS: [],
        cancelationCCard: [],
        cancelationCSpace: [],
        cancelationCSCard: [],
        cancelationCSSpace: [],
        economicActivities: [],
        openpayPrefix: [],
        cardCustomization: [],
        customerOrigin: [],
    });

    const [menuItems, setMenuItems] = useState([]);
    const [secondaryMenu, setSecondaryMenu] = useState([]);
    const [valueSearch, setValueSearch] = useState('');
    const [menu, setMenu] = useState(false);
    const [widgets, setWidgets] = useState([]);
    const [next, setNext] = useState('');
    const [hasFilter, setHasFilter] = useState(false);

    const [searchType, setSearchType] = useState('email');
    const [codeCountry, setCodeCountry] = useState("52");
    const [nameType, setNameType] = useState({gname: "", lname: "", slname: ""});
    
    const [configDashboard, setConfigDashboard] = useState({});

    useEffect(() => {
        init();
    }, []);

    useEffect(() => {
        if(props.showSecondary && props.openMainMenu){
            showMenu()
        }
    }, [props.showSecondary]);
    useEffect(() => {
        if(hasAction('defaultSearchBar')){
            !props.openMainMenu && props.mainMenu();
        }
    }, [configDashboard]);

    const hasAction = (action) => {
        return configDashboard["actions"]?.indexOf(action) > -1;
    };
    const hasField = (field) => {
        return configDashboard["fields"]?.in?.indexOf(field) > -1;
    };

    const updateNext = (data) => {
        setNext(data);
    };

    const init = async () => {
        let session = JSON.parse(localStorage['session']);
        await getConfig(session['uuid']);
        await getAllCatalogs();

        let conf = localStorage.config ? JSON.parse(localStorage.config) : {};
        let roles = conf.idRol ? [conf.idRol] : [];

        switch (roles[0]) {
            case 'inext-role-customerService-manager':
            case 'inext-role-customerService-specialist':
            case 'inext-role-spei-operator':
                imgDefault(conf);
                break;
            case 'inext-role-compliance-analyst':
                complianceInit(1);
                break;
            case 'inext-role-compliance-manager':
                initComplianceManager();
                break;
            case 'inext-role-afb-kam':
                leadCrmList();
                break;
            case 'inext-role-afb-support':
                adminAbbList();
                break;
            case 'inext-role-logistics-operations':
                findLogisticsList();
                break;
            case 'inext-role-logistics-manager':
                logisticReport();
                break;
            case 'inext-role-IT-Ops':
            case 'inext-role-treasury-specialist':
                initItOps();
                break;
            case 'inext-role-growth':
                initGrowth();
                break;
            case 'inext-role-rewards-manager':
                initRewards();
                break;
            case 'inext-role-fraud-manager':
                for (let i = 0; i < conf.secondaryMenu.length; i++) {
                    console.log('conf.secondaryMenu[i]: ', conf.secondaryMenu[i]);
                    if (conf.secondaryMenu[i]["label"] === 'It Ops' && conf.secondaryMenu[i]["option"].indexOf('fraudList') > -1) {
                        await initFraud();
                        break
                    }
                }
                break;
            default:
                break;
        }

        if (conf['init']) {
            if (conf['init'] != 'initCLevel()') {
                await anyRequest(conf['init'], {});
            } else {
                await initCLevel();
            }
        }

        if(conf.idRol){
            let rol = conf.idRol;
            let request = await API.service('dashboard', {uuid: rol}, props.pos, props.changeAlert, props.changeLoader, history);
            if(request.data.data.response === "OK"){
                setConfigDashboard(request.data.data.widget[0].config)
            }
        }
    }

    const anyRequest = async (intent, data) => {
        props.changeLoader(true);
        let request = await API.service(intent, data, props.pos, props.changeAlert, props.changeLoader, history);
        if (request.status == 200) {
            if (request.data.data.response == 'OK') {
                filterSet();
                setWidgets(request.data.data.widget);
            }
        } else {
            setWidgets([]);
        }
        props.changeLoader(false);
    }

    const getConfig = async (uuid) => {
        let config = await API.service('getConfig', { uuid: uuid }, props.pos, props.changeAlert, props.changeLoader, history);
        if (config.status == 200 && config.data.data.response == 'OK') {
            props.changeSecondaryMenu(config.data.data.config.secondaryMenu);
            props.changeRolName(config.data.data.config.rolName);
            setMenuItems(JSON.parse(JSON.stringify(config.data.data.config.menu)));
            setSecondaryMenu(JSON.parse(JSON.stringify(config.data.data.config.secondaryMenu)));
            localStorage.config = JSON.stringify(config.data.data.config);
        } else {
            let response = await API.logout();
            if (response.status == 200) {
                delete localStorage.session;
                delete localStorage.config;
                history.push('/login', { logout: true });
            }
        }
    }

    const findWithSearch = (afb = false, type = searchType, name = nameType) => {
        let request: any = valueSearch;
        if(type !== "operation" && !afb){
            request = {
                data: {
                    customer: {
                        keyword: valueSearch
                    },
                    filters: {
                        results_per_page: 50,
                        page_number: 1,
                        search_type: type
                    }
                }
            }
            
            switch (type) {
                case "phone":
                    request.data.customer["keyword"] = "+" + codeCountry + valueSearch;
                    break;
                case "name":
                    request.data.customer = name;
                    request.data.customer["keyword"] = `${name["gname"]} ${name["lname"]} ${name["slname"]}`
                    break;
                default:
                    request.data.customer["keyword"] = valueSearch
                    break;
            }
        }
        if(afb){
            request = {
                data: {
                    customer: {
                        keyword: valueSearch,
                        origin: 'afb',
                        status: 'enabled'
                    },
                    filters: {
                        results_per_page: 50,
                        page_number: 1
                    }
                }
            }
        }

        return request;
    }

    const initCLevel = async () => {
        let session = JSON.parse(localStorage.session);
        props.changeLoader(true);
        let data = {
            page: 1,
            limit: 5,
        };

        let request = await API.service('initCLevel', data, props.pos, props.changeAlert, props.changeLoader, history);
        if (request.status == 200) {
            if (request.data.data.response == 'OK') {
                filterSet();
                setWidgets(request.data.data.widget);
            }
        } else {
            setWidgets([]);
        }
        props.changeLoader(false);
    }

    const clickSecondary = async (type) => {
        props.closeMenu();
        switch (type) {
            case 'data':
                await findDataPersonal();
                break;
            case 'accounts':
                await findSpaces();
                break;
            case 'accountStatement':
                await accountStatement();
                break;
            case 'cards':
                await findCards();
                break;
            case 'listTx':
                await findTx();
                break;
            case 'logisticList':
                await findLogisticsList();
                break;
            case 'manualCheck':
                await complianceInit(1);
                break;
            case 'logisticReport':
                await logisticReport();
                break;
            case 'cardsAfb':
                await cardsAfb();
                break;
            case 'assignAfb':
                await assignAfb();
                break;
            case 'stpRegister':
                await stpRegister();
                break;
            case 'getInfoVirtualCard':
                await getInfoVirtualCard();
                break;
            case 'assignClabe':
                await assignClabe();
                break;
            case 'serviceManager':
                await serviceManager();
                break;
            case 'companiesClients':
                await contactList();
                break;
            case 'companiesCards':
                await findCardsCompany();
                break;
            case 'afbCustomers':
                await afbCustomers();
                break;
            case 'assignRif':
                await assignRif();
                break;
            case 'createAfbCustomer':
                await createAfbCustomer();
                break;
            case 'createAfbSpace':
                await createAfbSpace();
                break;
            case 'alboCard':
                await alboCard();
                break;
            case 'reportCards':
                await reportCards();
                break;
            case 'alboCardCIH':
                await alboCardCIH();
                break;
            case 'accountBlockList':
                await accountBlockList();
                break;
            case 'blackWhiteList':
                await blackWhiteList();
                break;
            case 'concentratorMessages':
                await concentratorMessages();
                break;
            case 'reporteLogTutuka':
                await reporteLogTutuka();
                break;
            case 'complianceReport':
                await initComplianceManager();
                break;
            case 'consultLogsGCP':
                await consultLogsGCP();
                break;
            case 'leadList':
                await leadList();
                break;
            case 'admin':
                await admin();
                break;
            case 'adminRoles':
                await adminRoles();
                break;
            case 'adminScripts':
                await adminScripts();
                break;
            case 'adminFactors':
                await adminFactors();
                break;
            case 'adminUnits':
                await adminUnits();
                break;
            case 'alboQueryLanguaje':
                await alboQueryLanguaje();
                break;
            case 'reportManualValidation':
                await reportManualValidation();
                break;
            case 'tutukaOperationManual':
                await tutukaOperationManual();
                break;
            case 'adminAbbList':
                await adminAbbList();
                break;
            case 'cLevelReport':
                await cLevelReport();
                break;
            case 'transactionsLabels':
                await transactionsLabels();
                break;
            case 'assignAgreement':
                await assignAgreement();
                break;
            case 'limitsBalance':
                await limitsBalance();
                break;
            case 'massCustomerCancel':
                await massCustomerCancel();
                break;
            case 'massCustomerBlock':
                await massCustomerBlock();
                break;
            case 'massSpaceCancel':
                await massSpaceCancel();
                break;
            case 'r27':
                await r27();
                break;
            case 'leadsTrackingReport':
                await leadsTrackingReport();
                break;
            case 'devPld':
                await devPld();
                break;
            case 'inextManagerFeatures':
                await inextManagerFeatures();
                break;
            case 'afbAdminCards':
                await afbAdminCards();
                break;
            case 'singleCustomerView':
                await singleCustomerView();
                break;
            case 'leadCrmList':
                await leadCrmList();
                break;
            case 'customerVipList':
                await customerVipList();
                break;
            case 'generateTxInfo':
                await generateTxInfo();
                break;
            case 'taxPaymentGet':
                await taxPaymentGet();
                break;
            case 'companyList':
                await companyList();
                break;
            case 'validateClabe':
                await validateClabe();
                break;
            case 'afbPreloadWorkers':
                await afbPreloadWorkers();
                break;
            case 'commissionCrmList':
                await commissionCrmList();
                break;
            case 'sellerCrmList':
                await sellerCrmList();
                break;
            case 'afbInvestmentAdmin':
                await afbInvestmentAdmin();
                break;
            case 'spaceTxPending':
                await spaceTxPending();
                break;
            case 'agentAuthSignature':
                await agentAuthSignature();
                break;
            case 'afbRecurringList':
                await afbRecurringList();
                break;
            case 'queueManager':
                await queueManager();
                break;
            case 'massExpedientDownload':
                await massExpedientDownload();
                break;
            case 'insertBqChargeback':
                await insertBqChargeback();
                break;
            case 'customerHistoryGet':
                await customerHistoryGet();
                break;
            case 'afbFeeSimulation':
                await afbFeeSimulation();
                break;
            default:
                await anyRequest(type, {});
                break;
        }
    }

    const validateVip = async (widget, type) => {
        props.changeLoader(true);

        const agent = localStorage.session ? JSON.parse(localStorage.session) : {};
        let customer = {};
        let fields = widget["config"]["fields"]

        switch (type) {
            case "dataPersonal":
                customer = widget.content
                break;
            case "findStatementClients":
                customer = widget.content.data[0]
                break;
            case "cuentas":
            case "spaceListTx":
                customer = widget.data.content[0]
                break;
            default:
                break;
        };

        if(!(fields?.in?.indexOf("vip") > -1) && customer && customer["vip"] && customer["taxid"] !== agent["taxid"]){
            let data = {
                agent: agent["email"],
                customer: customer["email"],
                type: widgetDescription[type]
            };
            let response = await API.service('sendSlack', data, props.pos, props.changeAlert, props.changeLoader, history);
            if (response.status == 200 && response.data.data.response == 'OK') {
                return false;
            };
        } else {
            return true;
        };
        
        props.changeLoader(false);
    };

    const openModalPld = async () => {
        if (!valueSearch.trim() && searchType !== "name") {
            return;
        }
        props.changeLoader(true);
        showMenu();

        let request = findWithSearch();
        let response = await API.service('pld', request, props.pos, props.changeAlert, props.changeLoader, history);
        if (response.status == 200 && response.data.data.response == 'OK') {
            let widg = [];
            widg = response.data.data.widget;
            filterSet();
            let customer = {
                uuid: ""
            }
            if (widg[0]?.type === 'pld') {
                let contentModal: any = {
                    name: widg[0].content.name
                }
                if (widg[0].content.uuid) {
                    contentModal.uuid = widg[0].content.uuid;
                    customer.uuid = widg[0].content.uuid;
                }

                props.changeLoader(false);
                const as = (
                    <PldModalController
                        data={null}
                        hide={true}
                        pos={props.pos}
                        spacesList={props.spacesList}
                        catalogs={catalogs}
                        spaceUuid={props.spaceUuid}
                        changeAlert={props.changeAlert}
                        changeLoader={props.changeLoader}
                        customer={customer}
                    />
                );

                openlightbox(as);
            } else {
                let widg = request.data.data.widget;
                setWidgets(JSON.parse(JSON.stringify(widg)));
            }
        }
    }

    const consultLogsGCP = async () => {
        props.changeLoader(true);
        let today = new Date();
        let startDate = createInitialDate(today.toJSON().substring(0, 10));
        let data = {
            date: startDate.substring(0, 10),
            name: 'catalog-init',
            page: 1,
            limit: 2
        };

        let response = await API.service('consultLogsGCP', data, props.pos, props.changeAlert, props.changeLoader, history);
        if (response.status == 200 && response.data.data.response == 'OK') {
            let widget = response.data.data.widget[0]
            
            setWidgets([widget]);
            props.changeLoader(false);
        } else {
            setWidgets([]);
            props.changeLoader(false);
        }
    }

    const createDateNumbers = (y, m, d) => {
        let initial = new Date(y, m, d);
        let timeZone = moment(initial.toJSON().substring(0, 10)).tz('America/Mexico_City').toJSON();
        return new Date(timeZone).toJSON();
    }

    const createInitialDate = (date) => {
        let initial = new Date(date);
        let timeZone = moment(initial.toJSON().substring(0, 10)).tz('America/Mexico_City').toJSON();
        return new Date(timeZone).toJSON();
    }

    const createFinalDate = (date) => {
        let ending = new Date(date);
        let end = new Date((ending.getTime()) - 1);
        let timeZone = moment(end.toJSON().substring(0, 10)).tz('America/Mexico_City').toJSON();
        return new Date(timeZone).toJSON();
    }

    const filterSet = () => {
        if (typeof (valueSearch) == "string" && valueSearch.trim().length > 0) {
            setHasFilter(true);
        }
    }

    const cLevelReport = async () => {
        props.changeLoader(true);
        showMenu();

        let data = {
            page: 1,
            limit: 10,
            type: 'history',
        }

        let widgetsCLevel = await API.service('cLevelReport', data, props.pos, props.changeAlert, props.changeLoader, history);
        if (widgetsCLevel.status == 200) {
            if (widgetsCLevel.data.data.response == 'OK') {
                filterSet();
                setWidgets(widgetsCLevel.data.data.widget);
            }
        } else {
            setWidgets([]);
        }
        props.changeLoader(false);
    }

    const initComplianceManager = async () => {
        props.changeLoader(true);
        

        let today = new Date();
        let startDate = createInitialDate(today.toJSON().substring(0, 10));
        let arrayDate = today.toJSON().substring(0, 10).split('-');
        let endDay = (Number(arrayDate[2]) + 1).toString().padStart(2, '0');
        let endDate = createDateNumbers(arrayDate[0], Number(arrayDate[1]) - 1, endDay);

        let data = {
            startDate: startDate,
            endDate: endDate,
            type: 'agents'
        };

        let widgetsCompliance = await API.service('complianceReport', data, props.pos, props.changeAlert, props.changeLoader, history);
        if (widgetsCompliance.status == 200) {
            if (widgetsCompliance.data.data.response == 'OK') {
                filterSet();
                setWidgets(widgetsCompliance.data.data.widget);
            }
        } else {
            setWidgets([]);
        }
        props.changeLoader(false);
    }

    const accountBlockList = async () => {
        props.changeLoader(true);
        const as = <AccountBlockList
            catalogs={catalogs}
            pos={props.pos}
            changeAlert={props.changeAlert}
            changeLoader={props.changeLoader}
            key="accountBlockList"
        />
        openlightbox(as);
        props.changeLoader(false);
    }

    const blackWhiteList = async () => {
        props.changeLoader(true);
        

        let data = {
            typeList: "black",
            page_number: 1,
            results_per_page: 50
        }
        let request = await API.service('blackWhiteList', data, props.pos, props.changeAlert, props.changeLoader, history);
        if (request.status == 200) {
            if (request.data.data.response == 'OK') {
                setWidgets([]);
                let widg = [];
                widg = request.data.data.widget;
                setWidgets(JSON.parse(JSON.stringify(widg)));
            } else {
                setWidgets([]);
            }
        } else {
            setWidgets([]);
        }
        props.changeLoader(false);
    }

    const assignRif = async () => {
        if (valueSearch.trim().length == 0 && searchType !== "name") {
            return;
        }
        
        props.changeLoader(true);
        showMenu();

        let request = findWithSearch()
        let response = await API.service('assignRif', request, props.pos, props.changeAlert, props.changeLoader, history);
        if (response.status == 200) {
            if (response.data.data.response == 'OK') {
                setWidgets([]);
                let widg = [];
                widg = response.data.data.widget;
                if (widg[0].type == 'assignRif' && widg[0]?.content) {
                    const as = <AssignRif
                        pos={props.pos}
                        changeAlert={props.changeAlert}
                        changeLoader={props.changeLoader}
                        contentModal={widg[0]?.content}
                        key="assignRif"
                    />
                    openlightbox(as);
                } else {
                    setWidgets(JSON.parse(JSON.stringify(widg)));
                }
            } else {
                setWidgets([]);
            }
        } else {
            setWidgets([]);
        }
        props.changeLoader(false);
    }

    const contactList = async () => {
        if (valueSearch.trim().length == 0) {
            return;
        }
        props.changeLoader(true);
        showMenu();

        let data = {
            find: valueSearch,
            limit: 20,
            page: 1
        }

        let request = await API.service('contactList', data, props.pos, props.changeAlert, props.changeLoader, history);
        if (request.status == 200) {
            if (request.data.data.response == 'OK') {
                setWidgets([]);
                let widg = [];
                widg = request.data.data.widget;
                setWidgets(JSON.parse(JSON.stringify(widg)));
            } else {
                setWidgets([]);
            }
        } else {
            setWidgets([]);
        }
        props.changeLoader(false);
    }

    const findCardsCompany = async () => {
        if (valueSearch.trim().length == 0) {
            return;
        }
        props.changeLoader(true);
        showMenu();

        let request = await API.service('companyCards', valueSearch, props.pos, props.changeAlert, props.changeLoader, history);
        if (request.status == 200) {
            if (request.data.data.response == 'OK') {
                setWidgets([]);
                let widg = [];
                widg = request.data.data.widget;
                if (widg[0].type == 'companyCards' && widg[0]?.content) {
                    const as = <CardsCompany
                        pos={props.pos}
                        changeAlert={props.changeAlert}
                        changeLoader={props.changeLoader}
                        contentModal={widg[0]?.content}
                        key="companyCards" />
                    openlightbox(as);
                } else {
                    setWidgets(JSON.parse(JSON.stringify(widg)));
                }
            } else {
                setWidgets([]);
            }
        } else {
            setWidgets([]);
        }
        props.changeLoader(false);
    }

    const getAllCatalogs = async () => {
        props.changeLoader(true)
        let occupationAdd = [
            { v: 'Hogar', k: '1' },
            { v: 'Comercio/Independiente', k: '2' },
            { v: 'Sin empleo', k: '3' },
            { v: 'Jubilado/jubilada', k: '7' },
            { v: 'Pensionado/pensionada', k: '8' }
        ]
        let catalog = await API.service('getAllCatalogs', 'all', props.pos, props.changeAlert, props.changeLoader, history);
        if (catalog.status == 200 && catalog.data.data.response == 'OK') {
            setCatalogs({
                country: catalog.data.data.catalogs.countries,
                gender: catalog.data.data.catalogs.genders,
                states: catalog.data.data.catalogs.states,
                occupations: catalog.data.data.catalogs.occupations.concat(occupationAdd),
                civilStatus: catalog.data.data.catalogs.civilStatus,
                status: catalog.data.data.catalogs.status,
                banks: catalog.data.data.catalogs.banks,
                mccs: catalog.data.data.catalogs.mccs,
                cancelation: catalog.data.data.catalogs.cancelation,
                cancelationC: catalog.data.data.catalogs.cancelationC,
                cancelationCS: catalog.data.data.catalogs.cancelationCS,
                cancelationCustomer: catalog.data.data.catalogs.cancelationCustomer,
                blockC: catalog.data.data.catalogs.blockC,
                blockCS: catalog.data.data.catalogs.blockCS,
                cancelationCCard: catalog.data.data.catalogs.cancelationCCard,
                cancelationCSpace: catalog.data.data.catalogs.cancelationCSpace,
                cancelationCSCard: catalog.data.data.catalogs.cancelationCSCard,
                cancelationCSSpace: catalog.data.data.catalogs.cancelationCSSpace,
                economicActivities: catalog.data.data.catalogs.economicActivities,
                openpayPrefix: catalog.data.data.catalogs.openpayPrefix,
                cardCustomization: catalog.data.data.catalogs.cardCustomization,
                customerOrigin: catalog.data.data.catalogs.customerOrigin,
            });
        }
        setMakeOp(true);
        props.changeLoader(false);
    }

    const changeValue = (e) => {
        let value = e.target.value;

        if (value.indexOf('@') >= 0 && value.indexOf('&') == -1) {
            value = value.toLowerCase();
        }
        setValueSearch(value);
        let hidden = '';
        if (value.trim().length > 0) {
            hidden = '';
        } else {
            hidden = 'hidden';
        }
    }

    const updateValueSearch = (value) => {
        setValueSearch(value);
        setSearchType("email")
        setCodeCountry("52")
        setNameType({gname: "", lname: "", slname: ""})
    }

    const showMenu = () => {
        if(hasAction('defaultSearchBar')){
            setMenu(false);
        } else {
            props.mainMenu();
        }
    }

    const showMainMenu = () => {
        menu ? setMenu(false) : setMenu(true);
    }

    const changeWidgets = (data) => {
        setWidgets(data);
    }

    const connectDialogFlow = async () => {
        if (valueSearch.trim().length == 0) {
            return;
        }
        props.changeLoader(true);
        props.changeAlert(false, '', '');

        let request = await API.service('dialogflow', valueSearch, props.pos, props.changeAlert, props.changeLoader, history);

        if (request.status == 200) {
            if (request.data.data.response == 'OK') {
                let next = FUNC.responseDialogflow(request.data.data.dialogflow.action);
                find(next);
            } else {
                setWidgets([]);
            }
        }
    }

    const findDataPersonal = async () => {
        if (valueSearch.trim().length == 0 && searchType !== "name") {
            return;
        }
        props.changeLoader(true);
        showMenu();

        let request = findWithSearch();
        let response = await API.service('dataPersonal', request, props.pos, props.changeAlert, props.changeLoader, history);

        if (response.status == 200) {
            if (response.data.data.response == 'OK') {
                setWidgets([]);
                let widg = [];
                filterSet();
                widg = response.data.data.widget;
                validateVip(widg[0], "dataPersonal")
                setWidgets(JSON.parse(JSON.stringify(widg)));
                
                // const widget = [{
                //     type: 'dataPersonalSections',
                //     data: response.data.data.widget
                // }]
                // setWidgets(JSON.parse(JSON.stringify(widget)));

            } else {
                setWidgets([]);
            }
        } else {
            setWidgets([]);
        }
        props.changeLoader(false);
    }

    const find = async (step) => {
        if (step.type !== "name" && !step.value.trim() ) {
            return;
        }
        if (step.type === "name" && step.value ) {
            setNameType(JSON.parse(JSON.stringify(step.value)))
        }
        
        setValueSearch(JSON.parse(JSON.stringify(step.value)));
        setSearchType(JSON.parse(JSON.stringify(step.type)));

        props.changeAlert(false, '', '');
        props.changeLoader(true);
        if(props.openMainMenu){
            showMenu()
        }

        let request = findWithSearch(false, step.type, step.type === "name" && step.value);
        let response = await API.service('free', request, props.pos, props.changeAlert, props.changeLoader, history);
        if (response.status == 200) {
            if (response.data.data.response == 'OK') {
                setWidgets([]);
                if (response.data.data.content) {
                    if (response.data.data.content.hasOwnProperty('download')) {
                        let files = response.data.data.content.hasOwnProperty('files') ? response.data.data.content.files : [];
                        for (let i = 0; i < files.length; i++) {
                            window.open(files[i], "Download");
                        }
                    }
                } else {
                    let widg = [];
                    widg = response.data.data.widget;
                    setWidgets(JSON.parse(JSON.stringify(widg)));
                    if (request?.data?.customer?.keyword?.includes("download-statement") && request?.data?.customer?.keyword?.includes("afb")) {
                        props.changeAlert(true, 'success',  response.data.data.message);
                    }
                }
            } else {
                setWidgets([]);
            }
        } else {
            setWidgets([]);
        }
        props.changeLoader(false);
    }

    const onHandleAuto = (info) => {
        info.value && setValueSearch(JSON.parse(JSON.stringify(info.value)));
        info.type && setSearchType(JSON.parse(JSON.stringify(info.type)));
        
    }

    const complianceInit = async (page) => {

        props.changeUpdate(0);
        props.changeLoader(true);
        

        let widgetsCompliance = await API.service('complianceInit', page, props.pos, props.changeAlert, props.changeLoader, history);
        if (widgetsCompliance.status == 200) {
            if (widgetsCompliance.data.data.response == 'OK') {
                setWidgets(widgetsCompliance.data.data.widget);
            }
        } else {
            setWidgets([]);
        }
        props.changeLoader(false);
        //let 
    }

    const accountStatement = async () => {
        if (!valueSearch.trim() && searchType !== "name") {
            return;
        }
        props.changeLoader(true);
        showMenu();
        let req = findWithSearch();

        let request = await API.service('findStatementClients', req, props.pos, props.changeAlert, props.changeLoader, history);
        if (request.status == 200 && request.data.data.response == 'OK') {
            filterSet();
            let widg = request.data.data.widget[0].content.data[0];
            let valRequest = await validateVip(request.data.data.widget[0], "findStatementClients")
            if(valRequest){
                let data = {
                    customerUuid: widg.uuid,
                    nextAction: "openModalStatementAccount",
                    customer: {
                        data: { results: [{general: widg}] }
                    }
                }
    
                let reqStatement = await API.service("openModalStatementAccount", data, props.pos, props.changeAlert, props.changeLoader, history);
                if(reqStatement.status == 200 && reqStatement.data.data.response == 'OK' && reqStatement.data.data.content){
                    if(reqStatement.data.data.content.type == '2FA' || reqStatement.data.data.content.type == '1FA'){
                        let factors = localStorage.factors ? JSON.parse(localStorage.factors) : {};
                        
                        factors[widg.uuid] = reqStatement.data.data.content.uuid_factor;
                        localStorage.factors = JSON.stringify(factors);
                    }
                    const as = <Factor
                        intent={"openModalStatementAccount"}
                        contentModal={reqStatement.data.data.content}
                        pos={props.pos}
                        changeAlert={props.changeAlert}
                        changeLoader={props.changeLoader}
                        history={history}
                        key="factor"
                    />
                    openlightbox(as);
                }
                if (reqStatement.status == 200 && reqStatement.data.data.response == 'OK') {
                    let widg = reqStatement.data.data.widget;
                    filterSet();
        
                    setWidgets([]);
                    setWidgets(JSON.parse(JSON.stringify(widg)));
        
                    if (widg[0]?.type === 'estadoCuenta' && widg[0]?.data?.content) {
                        const as = <AccountStatement dataCustomer={widg[0]?.data?.content} spaces={widg[0]?.data?.spaces}
                            pos={props.pos}
                            changeAlert={props.changeAlert}
                            changeLoader={props.changeLoader}
                            config={ widg[0]?.config}
                            key="accountStatement" />
                        openlightbox(as);
                    }
                }

            } else {
                props.changeAlert(true, 'error', 'No tienes permisos suficientes para consultar la información solicitada');
            }
        }


        props.changeLoader(false);
    }

    const findCards = async () => {
        if (!valueSearch.trim() && searchType !== "name") {
            return;
        }
        props.changeLoader(true);
        showMenu();

        let request = findWithSearch();
        let response = await API.service('tarjetas', request, props.pos, props.changeAlert, props.changeLoader, history);

        if (response.status == 200 && response.data.data.response == 'OK') {
            let widg = response.data.data.widget;
            filterSet();
            setWidgets(JSON.parse(JSON.stringify(widg)));
        }
        props.changeLoader(false);
    }

    const findSpaces = async () => {
        if (!valueSearch.trim() && searchType !== "name") {
            return;
        }
        props.changeLoader(true);
        showMenu();

        let request = findWithSearch();
        let response = await API.service('cuentas', request, props.pos, props.changeAlert, props.changeLoader, history);
        if (response.status == 200) {
            if (response.data.data.response == 'OK') {
                let widg = response.data.data.widget;
                filterSet();
                setWidgets([]);
                validateVip(widg[0], "cuentas");
                setWidgets(JSON.parse(JSON.stringify(widg)));
            } else {
                setWidgets([]);
            }
        }
        props.changeLoader(false);
    }

    const presDown = (event) => {
        event.target.name === "textField_1" && setMenu(true);
    };

    const findTx = async () => {
        if (!valueSearch.trim()) {
            return;
        }

        if (valueSearch.includes("os-space") && searchType !== "operation") {
            props.changeAlert(true, 'error', 'Selecciona el filtro: Operación');
            return;
        }

        localStorage.setItem("valueSearch", valueSearch)

        let data = {
            text: valueSearch,
            space: { uuid: "" },
            filter: {
                genericFilters: [
                    { start_date: initDay },
                    { end_date: endDay }
                ],
                results_per_page: 50,
                page_number: 1
            }
        };
        props.changeLoader(true);
        showMenu();

        let request = await API.service('spaceListTx', data, props.pos, props.changeAlert, props.changeLoader, history);

        if (request.status == 200) {
            if (request.data.data.response == 'OK') {
                setNext('search');
                let widg = request.data.data.widget;
                filterSet();;
                for (let i = 0; i < widg.length; i++) {
                    if (widg[i]['type'] == 'spaceListTx') {
                        widg[i]['init'] = true;
                    }
                }
                validateVip(widg[0], "spaceListTx")
                setWidgets([]);
                setWidgets(JSON.parse(JSON.stringify(widg)));
            } else {
                setWidgets([]);
            }
        }
        props.changeLoader(false);
    }

    const findLogisticsList = async () => {
        props.changeLoader(true);
        

        let data = {
            page: 1,
            limit: 50,
            type: 'cards',
            status: 'assigned'
        };

        let widgetsLogistic = await API.service('logisticList', data, props.pos, props.changeAlert, props.changeLoader, history);
        if (widgetsLogistic.status == 200) {
            if (widgetsLogistic.data.data.response == 'OK') {
                setWidgets(widgetsLogistic.data.data.widget);
            }
        } else {
            setWidgets([]);
        }
        props.changeLoader(false);
    }

    const adminFactors = async () => {
        props.changeLoader(true);
        

        let widgetAdmin = await API.service('adminFactors', { status: 'enabled' }, props.pos, props.changeAlert, props.changeLoader, history);
        if (widgetAdmin.status == 200) {
            if (widgetAdmin.data.data.response == 'OK') {
                setWidgets(widgetAdmin.data.data.widget);
            }
        } else {
            setWidgets([]);
        }
        props.changeLoader(false);
    }

    const adminUnits = async () => {
        props.changeLoader(true);
        

        let widgetAdmin = await API.service('adminUnits', {}, props.pos, props.changeAlert, props.changeLoader, history);
        if (widgetAdmin.status == 200) {
            if (widgetAdmin.data.data.response == 'OK') {
                setWidgets(widgetAdmin.data.data.widget);
            }
        } else {
            setWidgets([]);
        }
        props.changeLoader(false);
    }

    const adminRoles = async () => {
        props.changeLoader(true);
        

        let widgetAdmin = await API.service('adminRoles', {}, props.pos, props.changeAlert, props.changeLoader, history);
        if (widgetAdmin.status == 200) {
            if (widgetAdmin.data.data.response == 'OK') {
                setWidgets(widgetAdmin.data.data.widget);
            }
        } else {
            setWidgets([]);
        }
        props.changeLoader(false);
    }

    const adminScripts = async () => {
        props.changeLoader(true);
        

        let widgetAdmin = await API.service('adminScripts', { type: 'highlevel' }, props.pos, props.changeAlert, props.changeLoader, history);
        if (widgetAdmin.status == 200) {
            if (widgetAdmin.data.data.response == 'OK') {
                setWidgets(widgetAdmin.data.data.widget);
            }
        } else {
            setWidgets([]);
        }
        props.changeLoader(false);
    }

    const inextManagerFeatures = async () => {
        props.changeLoader(true);
        let widgetAdmin = await API.service('inextManagerFeatures', {}, props.pos, props.changeAlert, props.changeLoader, history);
        if (widgetAdmin.status == 200) {
            if (widgetAdmin.data.data.response == 'OK') {
                setWidgets(widgetAdmin.data.data.widget);
            }
        } else {
            setWidgets([]);
        }
        props.changeLoader(false);
    }

    const admin = async () => {
        props.changeLoader(true);
        

        let widgetAdmin = await API.service('admin', {}, props.pos, props.changeAlert, props.changeLoader, history);
        if (widgetAdmin.status == 200) {
            if (widgetAdmin.data.data.response == 'OK') {
                setWidgets(widgetAdmin.data.data.widget);
            }
        } else {
            setWidgets([]);
        }
        props.changeLoader(false);
    }

    const logisticReport = async () => {
        props.changeLoader(true);
        

        let date = new Date().toJSON().substring(0, 10).split('-');
        let startDate = new Date(moment(`${date[0]}-${date[1]}-01`).tz('America/Mexico_City').format()).toJSON();
        let endDay = new Date(Number(date[0]), Number(date[1]), 0).getDate();
        let endDate = createDateNumbers(date[0], Number(date[1]) - 1, endDay);

        let data = {
            startDate: startDate,
            endDate: endDate,
            type: 'agents'
        };

        let widgetsLogistic = await API.service('logisticReport', data, props.pos, props.changeAlert, props.changeLoader, history);
        if (widgetsLogistic.status == 200) {
            if (widgetsLogistic.data.data.response == 'OK') {
                setWidgets([]);
                let widg = [];
                widg = widgetsLogistic.data.data.widget;
                setWidgets(JSON.parse(JSON.stringify(widg)));
            }
        } else {
            setWidgets([]);
        }
        props.changeLoader(false);
    }

    const refreshPage = () => {
        window.location.reload();
    }

    const liClassName = (i) => {
        return `tap ${i < (menuItems.length - 2 + menuItems.length % 2) ? 'bottom-line' : ''}`
    }

    const reportCards = async () => {
        props.changeLoader(true);

        let date = new Date().toJSON().substring(0, 10).split('-');
        let startDate = new Date(moment(`${date[0]}-${date[1]}-01`).tz('America/Mexico_City').format()).toJSON();
        let endDay = new Date(Number(date[0]), Number(date[1]), 0).getDate();
        let endDate = createDateNumbers(date[0], Number(date[1]) - 1, endDay);

        let data = {
            type_card: "retail",
            resultsPerPage: 50,
            pageNumber: 1,
            genericFilters: [
                {
                    start_date: startDate
                },
                {
                    end_date: endDate
                }
            ]
        }
        let request = await API.service('reportCards', data, props.pos, props.changeAlert, props.changeLoader, history);
        if (request.status == 200) {
            if (request.data.data.response == 'OK') {
                setWidgets([]);
                let widg = [];
                widg = request.data.data.widget;
                setWidgets(JSON.parse(JSON.stringify(widg)));
            } else {
                setWidgets([]);
            }
        } else {
            setWidgets([]);
        }
        props.changeLoader(false);
    }

    const initItOps = async () => {
        props.changeLoader(true);
        setWidgets([{
            type: 'alboQueryLanguaje',
            content: {
                data: []
            },
        }]);
        props.changeLoader(false);
    }

    const cardsAfb = async () => {
        props.changeAlert(false, '', '');
        if (!valueSearch.trim()) {
            return;
        }
        showMenu();
        var s = valueSearch.split('&');
        if (s.length != 2 || s[1].trim().length == 0 || s[1].trim().split(',').length == 0) {
            props.changeAlert(true, 'error', 'Falta agregar datos');
            return;
        }
        props.changeLoader(true);


        let data = {
            rfc: s[0],
            cards: s[1].split(',')
        }
        let request = await API.service('cardsAfb', data, props.pos, props.changeAlert, props.changeLoader, history);
        if (request.status == 200) {
            if (request.data.data.response == 'OK') {
                props.changeAlert(true, 'success', 'Tarjetas solicitadas correctamente');
            } else {
                setWidgets([]);
            }
        }
        props.changeLoader(false);
    }

    const assignAfb = async () => {
        props.changeAlert(false, '', '');
        if (!valueSearch.trim()) {
            return;
        }

        var s = valueSearch.split('&');
        if (s.length != 2 || s[1].trim().length == 0 || s[1].trim().length == 0) {
            props.changeAlert(true, 'error', 'Falta agregar datos');
            return;
        }
        props.changeLoader(true);
        showMenu();

        let data = {
            rfc: s[0],
            customer: s[1]
        }
        let request = await API.service('assignAfb', data, props.pos, props.changeAlert, props.changeLoader, history);
        if (request.status == 200) {
            if (request.data.data.response == 'OK') {
                props.changeAlert(true, 'success', request.data.data.message);
            } else {
                setWidgets([]);
            }
        }
        props.changeLoader(false);
    }

    const stpRegister = async () => {
        if (!valueSearch.trim() && searchType !== "name") {
            return;
        }

        props.changeAlert(false, '', '');
        props.changeLoader(true);
        showMenu();
        let request = findWithSearch();
        let response = await API.service('listStpRegister', request, props.pos, props.changeAlert, props.changeLoader, history);
        if (response.status == 200 && response.data.data.response == 'OK') {
            let widg = [];
            widg = response.data.data.widget;
            setWidgets(JSON.parse(JSON.stringify(widg)));
        }
        props.changeLoader(false);
    }

    const getInfoVirtualCard = async () => {
        if (!valueSearch.trim() && searchType !== "name") {
            return;
        }
        props.changeLoader(true);
        showMenu();

        let request = findWithSearch();
        let response = await API.service('getInfoVirtualCard', request, props.pos, props.changeAlert, props.changeLoader, history);
        if (response.status == 200 && response.data.data.response == 'OK') {
            let widg = [];
            widg = response.data.data.widget;
            if (widg[0]?.type === 'infoVirtualCard') {
                const as = <InfoVirtualCard
                    contentModal={widg[0].content}
                    pos={props.pos}
                    changeAlert={props.changeAlert}
                    changeLoader={props.changeLoader}
                    key="infoVirtualCard" />
                openlightbox(as);
            } else {
                let widg = response.data.data.widget;
                setWidgets(JSON.parse(JSON.stringify(widg)));
            }
        }
        props.changeLoader(false);
    }

    const assignClabe = async () => {
        if (!valueSearch.trim() && searchType !== "name") {
            return;
        }
        props.changeLoader(true);
        showMenu();

        let request = findWithSearch();
        let response = await API.service('assignClabe', request, props.pos, props.changeAlert, props.changeLoader, history);

        if (response.status == 200 && response.data.data.response == 'OK') {
            let widg = [];
            widg = response.data.data.widget;
            if (widg[0]?.type === 'successAssign') {
                const as = <SuccessAssign
                    contentModal={widg[0].content}
                    pos={props.pos}
                    changeAlert={props.changeAlert}
                    changeLoader={props.changeLoader}
                    key="successAssign" />
                openlightbox(as);
            } else {
                let widg = response.data.data.widget;
                setWidgets(JSON.parse(JSON.stringify(widg)));
            }
        }
        props.changeLoader(false);
    }

    const serviceManager = async () => {

        props.changeAlert(false, '', '');
        props.changeLoader(true);

        let request = await API.service('serviceManagerGet', {}, props.pos, props.changeAlert, props.changeLoader, history);

        if (request.status == 200) {
            let widg = request.data.data.widget;
            setWidgets(JSON.parse(JSON.stringify(widg)));
            updateNext('update');
        } else {
            setWidgets([]);
        }
        props.changeLoader(false);
    }

    const concentratorMessages = async () => {
        const as = <FilterDateMessage
            pos={props.pos}
            changeAlert={props.changeAlert}
            changeLoader={props.changeLoader}
            setWidgets={setWidgets}
            updateNext={updateNext}
            key="filterDateMessage"
        />
        openlightbox(as);
    }

    const afbCustomers = async () => {
        updateNext('search');
        setWidgets([{
            type: 'afbCustomers'
        }]);
    }

    const createAfbCustomer = async () => {
        updateNext('search');
        
        const as = <AfbCustomer
            catalogs={catalogs}
            pos={props.pos}
            changeAlert={props.changeAlert}
            changeLoader={props.changeLoader}
            key="afbCustomer" />
        openlightbox(as);
    }

    const adminAbbList = async () => {
        props.changeLoader(true);
        let data = {
            data: {
                filter: {},
                offset: 0,
                limit: 10
            }
        }
        let widgetAdmin = await API.service('adminAbbList', data, props.pos, props.changeAlert, props.changeLoader, history);
        if (widgetAdmin.status == 200) {
            if (widgetAdmin.data.data.response == 'OK') {
                let widget = widgetAdmin.data.data.widget[0]

                let content = {
                    users: widget.data.content.documents,
                    roles: widget.data.content.roles,
                    count: widget.data.content.count,
                    userList: true
                }
                let data = [{
                    config: widget.config,
                    content: content,
                    type: widget.type
                }]
                setWidgets(data);
            }
        } else {
            setWidgets([]);
        }
        props.changeLoader(false);
    }

    const createAfbSpace = async () => {
        if (!valueSearch.trim() && searchType !== "name") {
            return;
        }
        
        props.changeLoader(true);
        showMenu();

        let request = findWithSearch(true);
        let response = await API.service('afbSpaceList', request, props.pos, props.changeAlert, props.changeLoader, history);
        if (response.status == 200 && response.data.data.response == 'OK') {
            let widg = [];
            widg = response.data.data.widget;
            if (widg[0]?.type === 'afbSpaceCreate') {
                const as = <AfbSpace
                    data={widg[0].content}
                    config={widg[0].config}
                    pos={props.pos}
                    changeAlert={props.changeAlert}
                    changeLoader={props.changeLoader}
                    key="afbSpaceCreate" />
                openlightbox(as);
            } else {
                let widg = response.data.data.widget;
                setWidgets(JSON.parse(JSON.stringify(widg)));
            }
        }
        props.changeLoader(false);
    }

    const alboCard = async () => {
        if (!valueSearch.trim() && searchType !== "name") {
            return;
        }
        props.changeLoader(true);
        showMenu();

        let request = findWithSearch(true)

        let response = await API.service('alboCard', request, props.pos, props.changeAlert, props.changeLoader, history);
        if (response.status == 200 && response.data.data.response == 'OK') {
            let widg = [];
            widg = response.data.data.widget;
            if (widg[0]?.type === 'alboCard') {
                const as = <AlboCard
                    data={widg[0].content}
                    catalogs={catalogs}
                    pos={props.pos}
                    changeAlert={props.changeAlert}
                    changeLoader={props.changeLoader}
                    key="alboCard" />
                openlightbox(as);
            } else {
                let widg = response.data.data.widget;
                setWidgets(JSON.parse(JSON.stringify(widg)));
            }
        }
        props.changeLoader(false);
    }

    const alboCardCIH = async () => {
        if (!valueSearch.trim() && searchType !== "name") {
            return;
        }
        props.changeLoader(true);
        showMenu();

        let data = {
            catalog: {
                id: 'card_customization'
            }
        };

        let request = findWithSearch();
        let requestFind = await API.service('alboCardCIH', request, props.pos, props.changeAlert, props.changeLoader, history);
        let response = await API.service('getCatalog', data, props.pos, props.changeAlert, props.changeLoader, history);


        if (requestFind.status == 200 && requestFind.data.data.response == 'OK') {
            let widg = [];
            widg = requestFind.data.data.widget;
            if (widg[0]?.type === 'alboCardCIH') {
                const as = <AlboCardCIH
                    data={widg[0].content}
                    catalogs={catalogs}
                    customCard={response?.data?.data?.catalog}
                    pos={props.pos}
                    changeAlert={props.changeAlert}
                    changeLoader={props.changeLoader}
                    key="alboCardCIH" />
                openlightbox(as);
            } else {
                let widg = requestFind.data.data.widget;
                setWidgets(JSON.parse(JSON.stringify(widg)));
            }
        }
        props.changeLoader(false);
    }

    const reporteLogTutuka = async () => {
        props.changeLoader(true);
        

        let today = new Date();
        let newToday = moment(today.toJSON()).tz('America/Mexico_City');
        let newDate = new Date(newToday.toJSON());
        let y = newDate.getFullYear();
        let m = ((newDate.getMonth()) + 1).toString().padStart(2, '0');
        let d = (newDate.getDate()).toString().padStart(2, '0');
        let startDate = createInitialDate(`${y}-${m}-${d}`);
        let arrayDate = newToday.toJSON().substring(0, 10).split('-');
        let endDay = (Number(d) + 1).toString().padStart(2, '0');
        let endDate = createDateNumbers(y, (Number(m) - 1), endDay);
        let endDateTime = (new Date(endDate).getTime()) - 1;
        let finalDate = new Date(endDateTime).toJSON();

        let data = {
            type: 'local',
            data: {
                page_number: 1,
                results_per_page: 50,
                filters: {
                    start_date: startDate,
                    end_date: finalDate
                }
            }
        }

        let request = await API.service('reporteLogTutuka', data, props.pos, props.changeAlert, props.changeLoader, history);

        if (request.status == 200) {
            if (request.data.data.response == 'OK') {
                setWidgets([]);
                let widg = [];
                widg = request.data.data.widget;
                setWidgets(JSON.parse(JSON.stringify(widg)));
            } else {
                setWidgets([]);
            }
        } else {
            setWidgets([]);
        }
        props.changeLoader(false);
    }

    const leadList = async () => {
        props.changeLoader(true);
        

        let today = new Date();
        let newToday = moment(today.toJSON()).tz('America/Mexico_City');
        let newDate = new Date(newToday.toJSON());
        let y = newDate.getFullYear();
        let m = ((newDate.getMonth()) + 1).toString().padStart(2, '0');
        let d = (newDate.getDate()).toString().padStart(2, '0');
        let startDate = createInitialDate(`${y}-${m}-${d}`);
        let arrayDate = newToday.toJSON().substring(0, 10).split('-');
        let endDay = (Number(d) + 1).toString().padStart(2, '0');
        let endDate = createDateNumbers(y, (Number(m) - 1), endDay);
        let endDateTime = (new Date(endDate).getTime()) - 1;
        let finalDate = new Date(endDateTime).toJSON();

        let data = {
            data: {
                page_number: 1,
                result_per_page: 50,
                start_date: startDate,
                end_date: finalDate
            }
        }

        let request = await API.service('leadList', data, props.pos, props.changeAlert, props.changeLoader, history);

        if (request.status == 200) {
            if (request.data.data.response == 'OK') {
                setWidgets([]);
                let widg = [];
                widg = request.data.data.widget;
                filterSet();
                setWidgets(JSON.parse(JSON.stringify(widg)));
            } else {
                setWidgets([]);
            }
        } else {
            setWidgets([]);
        }
        props.changeLoader(false);
    }

    const alboQueryLanguaje = async () => {
        const as = <AlboQueryLanguaje
            pos={props.pos}
            changeAlert={props.changeAlert}
            changeLoader={props.changeLoader}
            contentModal={valueSearch}
            setWidgets={setWidgets}
            updateNext={updateNext}
            key="alboQueryLanguaje"
        />
        openlightbox(as);
    }

    const reportManualValidation = async () => {
        props.changeLoader(true);
        

        let data = {
            filter: {
                end_date: new Date().toISOString().split("T")[0],
                start_date: moment().subtract(3, 'months').format().split("T")[0],
                status: "manual",
                page_number: 1,
                results_per_page: 50,
            }
        }
        let request = await API.service('reportManualValidation', data, props.pos, props.changeAlert, props.changeLoader, history);
        if (request.status == 200) {
            if (request.data.data.response == 'OK') {
                filterSet();
                setWidgets([]);
                let widg = [];
                widg = request.data.data.widget;
                setWidgets(JSON.parse(JSON.stringify(widg)));
            } else {
                setWidgets([]);
            }
        } else {
            setWidgets([]);
        }
        props.changeLoader(false);
    }

    const tutukaOperationManual = async () => {

        if (valueSearch.trim().length == 0 && searchType !== "name") {
            return;
        }
        props.changeLoader(true);
        showMenu();

        let request = findWithSearch();
        let response = await API.service('tutukaOpManual', request, props.pos, props.changeAlert, props.changeLoader, history);
        if (response.status == 200 && response.data.data.response == 'OK') {
            let widg = [];
            widg = response.data.data.widget;
            filterSet();

            if (widg[0]?.type === 'tutukaOpManual') {

                let contentModal: any = {
                    name: widg[0].content.name
                }
                if (widg[0].content.uuid) {
                    contentModal.uuid = widg[0].content.uuid;
                }

                const modalTutukaOpManual = <TutukaOperationManual
                    pos={props.pos}
                    changeAlert={props.changeAlert}
                    changeLoader={props.changeLoader}
                    contentModal={widg[0].content}
                    setWidgets={setWidgets}
                    updateNext={updateNext}
                    key="tutukaOpManual"
                />

                openlightbox(modalTutukaOpManual);
            } else {
                let widg = response.data.data.widget;
                setWidgets(JSON.parse(JSON.stringify(widg)));
            }
        }
        props.changeLoader(false);
    }

    const transactionsLabels = async () => {
        props.changeLoader(true);
        const as = <TransactionsLabels
            catalogs={catalogs}
            pos={props.pos}
            changeAlert={props.changeAlert}
            changeLoader={props.changeLoader}
            key="transactionsLabels"
        />
        openlightbox(as);
        props.changeLoader(false);
    }

    const assignAgreement = async () => {
        props.changeLoader(true);
        const as = <AssignAgreement
            catalogs={catalogs}
            pos={props.pos}
            changeAlert={props.changeAlert}
            changeLoader={props.changeLoader}
            key="assignAgreement"
        />
        openlightbox(as);
        props.changeLoader(false);
    }

    const limitsBalance = async () => {
        props.changeLoader(true);
        const as = <LimitsBalance
            pos={props.pos}
            changeAlert={props.changeAlert}
            changeLoader={props.changeLoader}
            setWidgets={setWidgets}
            updateNext={updateNext}
            key="limitsBalance"
        />
        openlightbox(as);
        props.changeLoader(false);
    }

    const massCustomerCancel = async () => {
        updateNext('search');
        setWidgets([{
            type: 'massCustomerCancel'
        }]);
    }

    const massCustomerBlock = async () => {
        updateNext('search');
        setWidgets([{
            type: 'massCustomerBlock'
        }]);
    }
    
    const massSpaceCancel = async () => {
        updateNext('search');
        setWidgets([{
            type: 'massSpaceCancel'
        }]);
    }

    const r27 = async () => {
        props.changeLoader(true);
        let today = new Date();        
        
        var data = {
            operation: "getByPeriod",
            data: {
                start: initDay,
                end: today.toJSON(),
                filters: {
                    page_number: 1,
                    results_per_page: 20
                }
            }
        }

        let request = await API.service('r27', data, props.pos, props.changeAlert, props.changeLoader, props.history);
        if (request.status == 200) {
            if (request.data.data.response == 'OK') {
                setWidgets([]);
                let widg = [];
                widg = request.data.data.widget;
                setWidgets(JSON.parse(JSON.stringify(widg)));
                props.changeLoader(false);
            } else {
                props.changeLoader(false);
                setWidgets([]);
            }
        } else {
            props.changeLoader(false);
            setWidgets([]);
        }
    }
    const leadsTrackingReport = async () => {
        props.changeLoader(true);

        const response = await API.service('leadsTrackingReport', {}, props.pos, props.changeAlert, props.changeLoader, props.history);
        if (response.status == 200 && response.data.data.response == 'OK') {
            let widg = response.data.data.widget;
            setWidgets(JSON.parse(JSON.stringify(widg)));
        } else {
            setWidgets([]);
        }

        props.changeLoader(false);
    }

    const featureCustomerGet = async () => {
        if (!valueSearch.trim()) {
            return;
        }
        props.changeLoader(true);
        showMenu();
        let request = findWithSearch();
        let payload = {
            data: {
                customer_uuid: request,
            }
        }
        const response = await API.service('featureCustomerGet', payload, props.pos, props.changeAlert, props.changeLoader, props.history);
        if (response.status == 200 && response.data.data.response == 'OK') {
            const widget = response.data.data.widget[0]
            setWidgets([widget]);
        } else {
            setWidgets([]);
        }
        props.changeLoader(false);
    }

    const initGrowth = async () => {
        props.changeLoader(true);

        const widget = {
            type: 'couponsReport',
        }
        setWidgets([widget]);
        

        props.changeLoader(false);
    }

    const initFraud = async () => {

        props.changeLoader(true);
        let data = {
            operation: "moneyout",
            type: "blacklist",
            count: 10
        }
  
        const response = await API.service('fraudList', data, props.pos, props.changeAlert, props.changeLoader, props.history);
        if (response.status == 200 && response.data.data.response == 'OK') {
            const widget = response.data.data.widget[0]
            setWidgets([widget]);
            props.changeLoader(false);
        } else {
            setWidgets([]);
            props.changeLoader(false);
        }

    }

    const devPld = async () => {
        props.changeLoader(true)
        let data = {
            type:"get"
        }

        let request = await API.service('devPld', data, props.pos, props.changeAlert, props.changeLoader, history);

        if (request.status != 200  || request.data.data.response === "BAD" ) {
            props.changeAlert(true, 'error', request.data.data.message);
            props.changeLoader(false);
        }else{
            let contentModal = {
                title: 'Herramientas del desarrollador',
                data: request.data.data.content
            }        
    
            props.changeLoader(false)
            
            const as = <AdminFormsPLD
                pos={props.pos}
                contentModal={contentModal}
                changeAlert={props.changeAlert}
                changeLoader={props.changeLoader}
                key="devPld" />
            openlightbox(as);
        }
        

        props.changeLoader(false);
    }

    const afbAdminCards = async () => {
        props.changeLoader(true);
        let data = {
            filters: {
                type: ["worker"],
                status: ["acknowledged"],
                dates: {
                    start: startDate,
                    end: endDate
                },
            },
            pagination: {
                page_number: 1,
                results_per_page: 30
            }
        }
  
        const response = await API.service('afbCardSearch', data, props.pos, props.changeAlert, props.changeLoader, props.history);
        if (response.status == 200 && response.data.data.response == 'OK') {
            let widget = response.data.data.widget[0]
            widget["payload"] = data
            setWidgets([widget]);
            props.changeLoader(false);
        } else {
            setWidgets([]);
            props.changeLoader(false);
        }
    }

    const singleCustomerView = async () => {
        if (!valueSearch.trim()) {
            return;
        }
        props.changeLoader(true);
        showMenu();
        let request = {
            data: {
                customer_uuid: valueSearch
            }
        }
        const response = await API.service('singleCustomerView', request, props.pos, props.changeAlert, props.changeLoader, props.history);
        if (response.status == 200 && response.data.data.response == 'OK') {
            const widget = response.data.data.widget[0]
            setWidgets([widget]);
        } else {
            setWidgets([]);
        }
        props.changeLoader(false);
    }

    const leadCrmList = async () => {
        props.changeLoader(true);
        const agent = localStorage.config ? JSON.parse(localStorage.config) : {};
        let data = {
            filters: {
                status_exclude: ["sql", "mql"],
                dates: {
                    start: moment().startOf('day').subtract(30, "days").toDate().toISOString().substring(0, 10),
                    end: moment().utc().endOf('day').toDate().toISOString().substring(0, 10)
                },
            },
            pagination: {
                page_number: 1,
                results_per_page: 30
            }
        }
        
        if (agent["crmInbound"]) {
            data.filters["crmContactFlow"] = "crmInbound"
        }
        if (agent["crmOutbound"]) {
            data.filters["crmContactFlow"] = "crmOutbound"
        }
        
        const response = await API.service('panelCrmList', data, props.pos, props.changeAlert, props.changeLoader, props.history);
        if (response.status == 200 && response.data.data.response == 'OK') {
            let widget = response.data.data.widget[0]
            widget["payload"] = "afb";
            widget["crmContactFlow"] = data.filters["crmContactFlow"];
            setWidgets([widget]);
            props.changeLoader(false);
        } else {
            setWidgets([]);
            props.changeLoader(false);
        }
    }

    const commissionCrmList = async () => {
        props.changeLoader(true);
        let data = {
            filters: {
                type: "lead"
            },
            pagination: {
                page_number: 1,
                results_per_page: 20
            }
        }
        
        const response = await API.service('commissionCrmList', data, props.pos, props.changeAlert, props.changeLoader, props.history);
        if (response.status == 200 && response.data.data.response == 'OK') {
            props.changeLoader(false);
            let widget = response.data.data.widget[0]
            setWidgets([widget]);
        } else {
            setWidgets([]);
            props.changeLoader(false);
        }
    }

    const sellerCrmList = async () => {
        props.changeLoader(true);
        let data = {
            filters: {},
            pagination: {
                page_number: 1,
                results_per_page: 20
            }
        }
        
        const response = await API.service('sellerCrmList', data, props.pos, props.changeAlert, props.changeLoader, props.history);
        if (response.status == 200 && response.data.data.response == 'OK') {
            let widget = response.data.data.widget[0]
            setWidgets([widget]);
            props.changeLoader(false);
        } else {
            setWidgets([]);
            props.changeLoader(false);
        }
    }

    const initRewards = async () => {
        props.changeLoader(true);
        
        let data = {
            catalog: {
                id: 'rewards_accumulators'
            }
        };

        let request = await API.service('getCatalog', data, props.pos, props.changeAlert, props.changeLoader, history);
        if (request.status == 200 && request.data.data.response == 'OK') {
            const widget = {
                type: 'rewardsPromotionsGet',
                catalog: request?.data?.data?.catalog
            }
            setWidgets([widget]);
            props.changeLoader(false);
        }
    }

    const customerVipList = async () => {
        props.changeLoader(true);
        let data = {
            filters: {
                active: true,
                type: "worker"
            },
            pagination: {
                page_number: 1,
                results_per_page: 30
            }
        }
        
        const response = await API.service('customerVipList', data, props.pos, props.changeAlert, props.changeLoader, props.history);
        if (response.status == 200 && response.data.data.response == 'OK') {
            let widget = response.data.data.widget[0]
            
            setWidgets([widget]);
            props.changeLoader(false);
        } else {
            setWidgets([]);
            props.changeLoader(false);
        }
    }

    const generateTxInfo = async () => {
        props.changeLoader(true);
        const as = <GenerateTxInfo
            open={true}
            changeAlert={props.changeAlert}
            changeLoader={props.changeLoader}
            key="queueManager"
        />
        openlightbox(as);
        props.changeLoader(false);
    }

    const taxPaymentGet = async () => {
        props.changeLoader(true);
        const as = <TaxPayment
            catalogs={catalogs}
            pos={props.pos}
            changeAlert={props.changeAlert}
            changeLoader={props.changeLoader}
            key="taxPaymentGet"
        />
        openlightbox(as);
        props.changeLoader(false);
    }

    const queueManager = async () => {
        const as = <QueueManager
            open={true}
            changeAlert={props.changeAlert}
            changeLoader={props.changeLoader}
            key="queueManager"
        />
        openlightbox(as);
    }
    const companyList = async () => {
        props.changeLoader(true);
        let request = {
            data: {
                filters: [{
                    status: "enabled"
                }],
                results_per_page: 10,
                page_number: 1
            }
        };
        
        const response = await API.service('companyList', request, props.pos, props.changeAlert, props.changeLoader, props.history);
        if (response.status == 200 && response.data.data.response == 'OK') {
            let widget = response.data.data.widget[0]
            
            setWidgets([widget]);
            props.changeLoader(false);
        } else {
            setWidgets([]);
            props.changeLoader(false);
        }
    }

    const afbPreloadWorkers = async () => {
        if (valueSearch.trim().length == 0 && searchType !== "name") {
            return;
        };
        
        props.changeLoader(true);
        showMenu();

        setWidgets([]);
        let request = findWithSearch(true);
        let response = await API.service('afbValidateCustomer', request, props.pos, props.changeAlert, props.changeLoader, history);
        if (response.status == 200 && response.data.data.response == 'OK') {
            let widg = [];
            widg = response.data.data.widget;

            setWidgets(JSON.parse(JSON.stringify(widg)));
            if (widg[0].type == 'afbPreloadWorkers' && widg[0]?.content) {
                const as = <AfbPreloadWorkers
                    changeAlert={props.changeAlert}
                    changeLoader={props.changeLoader}
                    content={widg[0]?.content}
                    open={true}
                    key="afbPreloadWorkers"
                />
                openlightbox(as);
            }

        }
        props.changeLoader(false);
    };

    const validateClabe = async () => {
        const as = <ValidateClabe
            changeAlert={props.changeAlert}
            changeLoader={props.changeLoader}
            setWidgets={setWidgets}
            updateNext={updateNext}
            open={true}
            key="validateClabe"
        />
        openlightbox(as);
    }

    const afbInvestmentAdmin = async () => {
        const as = <AfbInvestmentAdmin
            open={true}
            changeAlert={props.changeAlert}
            changeLoader={props.changeLoader}
            key="afbInvestmentAdmin"
        />
        openlightbox(as);
    }

    const spaceTxPending = async () => {
        props.changeLoader(true);
        let request = {
            origin: ["spei"],
            status: ["pending"],
        };
        
        const response = await API.service('spaceTxPending', request, props.pos, props.changeAlert, props.changeLoader, props.history);
        if (response.status == 200 && response.data.data.response == 'OK') {
            let widget = response.data.data.widget[0]
            
            setWidgets([widget]);
            props.changeLoader(false);
        } else {
            setWidgets([]);
            props.changeLoader(false);
        }
    }

    const agentAuthSignature = async () => {
        props.changeLoader(true);
        let data = {
            authSignature: true
        };

        let request = await API.service("agentAuthSignature", data, props.pos, props.changeAlert, props.changeLoader, history);
        if (request.status == 200 && request.data.data.response == "OK") {
            let content = request.data.data.content;
            props.changeLoader(false);
            const as = <SignatureAdmin
                open={true}
                data={content}
                changeAlert={props.changeAlert}
                changeLoader={props.changeLoader}
            />
            openlightbox(as);
        }
    };

    const afbRecurringList = async () => {
        props.changeLoader(true);
        let request = {
            data: {
                filter: {},
                pagination: {
                    page_number: 1,
                    results_per_page: 10
                }
            }
        };
        
        const response = await API.service('afbRecurringList', request, props.pos, props.changeAlert, props.changeLoader, props.history);
        if (response.status == 200 && response.data.data.response == 'OK') {
            let widget = response.data.data.widget[0];
            
            setWidgets([widget]);
            props.changeLoader(false);
        } else {
            setWidgets([]);
            props.changeLoader(false);
        }
    }

    const massExpedientDownload = async () => {
        const as = <MassExpedientDownload
            open={true}
            changeAlert={props.changeAlert}
            changeLoader={props.changeLoader}
            key="massExpedientDownload"
        />
        openlightbox(as);
    }

    const insertBqChargeback = async () => {
        props.changeLoader(true);
        const as = <InsertBQChargeback
            open={true}
            changeAlert={props.changeAlert}
            changeLoader={props.changeLoader}
            key="insertBqChargeback"
        />
        openlightbox(as);
        props.changeLoader(false);
    }

    
    const customerHistoryGet = async () => {
        if (!valueSearch.trim()) {
            return;
        }
        props.changeLoader(true);
        showMenu();

        let request = findWithSearch();
        let response = await API.service('customerHistoryLogin', request, props.pos, props.changeAlert, props.changeLoader, props.history);
        if (response.status == 200 && response.data.data.response == 'OK') {
            const widget = response.data.data.widget[0]
            setWidgets([widget]);
        } else {
            setWidgets([]);
        }
        props.changeLoader(false);
    }


    const afbFeeSimulation = async () => {
        setWidgets([{
            type: 'afbFeeSimulation',
        }]);
    }

    const imgDefault = async (conf) => {
        setWidgets([{
            type: 'imgDefault',
            rol: conf["rolName"]
        }]);
    }
    // End services ----------------------

    return (
        <>
        <ContentStyle>
            <ThemeProvider theme={theme} >
                <Grid container className={props.loader ? `${classes.blur}` : ""} >
                <Components.Bar
                    showMenu={showMenu}
                    openMenu={props.openMenu}
                    openSideBar={props.openSideBar}
                    rolName={props.rolName}
                    secondaryMenu={secondaryMenu}
                    openMainMenu={props.openMainMenu}
                    mainMenu={props.mainMenu}
                    pos={props.pos}
                    changeLoader={props.changeLoader}
                    changeAlert={props.changeAlert}
                />
                {
                    secondaryMenu.length > 0 && localStorage.config &&
                    <SecondaryMenu
                        showSecondary={props.showSecondary}
                        openMenu={props.openMenu}
                        closeMenu={props.closeMenu}
                        clickSecondary={clickSecondary}
                        changeAlert={props.changeAlert}
                        changeLoader={props.changeLoader}
                        pos={props.pos}
                    />
                }
                {
                    <Grid item>
                        <Components.SideBar
                            pos={props.pos}
                            changeAlert={props.changeAlert}
                            changeLoader={props.changeLoader}
                            openSideBar={props.openSideBar}
                            showSideBar={props.showSideBar}
                            closeSideBar={props.closeSideBar}
                        />
                    </Grid>
                }

                <Grid item container justifyContent={"center"} >
                    <Grid item >
                        {props.openMainMenu &&
                            <Box style={{width: '55%', transition: 'width 0.3s ease-in-out', justifyContent: 'center', position: 'fixed', top: '14px', right: '21%', zIndex: 50}}>
                                <CustomSearchBar
                                    field={true}
                                    select={{options: searchOptions, default: searchType || "email", catalogs: catalogs}}
                                    textField="Ingresa un dato del cliente"
                                    defaultField={valueSearch}
                                    onConfirm={find.bind(this)}
                                    startAdornment={
                                        <IconButton onClick={showMainMenu.bind(this)} edge="start" >
                                            <MenuIcon sx={{fontSize: '1.31rem', fontWeight: 900}}/>
                                        </IconButton>
                                    }
                                    onHandleAuto={onHandleAuto}
                                    onClickCaptureHandler={presDown}
                                    auto
                                />
                            </Box>
                        }

                        {props.openMainMenu && menu &&
                        <Grid item container px={"2.5rem"}> 
                            <Card 
                                sx={{width: "55%", p: "1rem", maxHeight: `${((Math.ceil(menuItems.length/2))* 3.7)+8}rem`, overflow: "auto", position: 'fixed', zIndex: 50, right: '21%', top: '75px'}} 
                                className={`fadeInDown animated`}>
                                    <Typography variant='subtitle2' className='neutral' p={"1rem"} fontSize={"0.875rem"}>
                                        Búsquedas por operación frecuente una vez ingresado un dato específico del cliente
                                    </Typography>
                                <Box sx={{flexFlow: "wrap",  display: "flex"}}>
                                {
                                    menuItems.map((menuItem, i) => {
                                        return searchType === 'operation' ? 
                                        {
                                            'listTx': <ListItem sx={{width: "50%"}} key={i} className={liClassName(i)} onClick={findTx}>Movimientos</ListItem>
                                        }[menuItem]
                                        :
                                        {
                                            'data': <ListItem sx={{width: "50%"}} key={i} className={liClassName(i)} onClick={findDataPersonal.bind(this)}>Datos del cliente</ListItem>,
                                            'accounts': <ListItem sx={{width: "50%"}} key={i} className={liClassName(i)} onClick={findSpaces}>Cuentas</ListItem>,
                                            'accountStatement': <ListItem sx={{width: "50%"}} key={i} className={liClassName(i)} onClick={accountStatement}>Estados de cuenta</ListItem>,
                                            'cards': <ListItem sx={{width: "50%"}} key={i} className={liClassName(i)} onClick={findCards}>Tarjetas</ListItem>,
                                            'listTx': <ListItem sx={{width: "50%"}} key={i} className={liClassName(i)} onClick={findTx}>Movimientos</ListItem>,
                                            'stpRegister': <ListItem sx={{width: "50%"}} key={i} className={liClassName(i)} onClick={stpRegister}>Alta de usuarios en STP</ListItem>,
                                            'getInfoVirtualCard': <ListItem sx={{width: "50%"}} key={i} className={liClassName(i)} onClick={getInfoVirtualCard}>Asignar tarjeta virtual</ListItem>,
                                            'assignClabe': <ListItem sx={{width: "50%"}} key={i} className={liClassName(i)} onClick={assignClabe}>Asignar CLABE</ListItem>,
                                            'assignRif': <ListItem sx={{width: "50%"}} key={i} className={liClassName(i)} onClick={assignRif}>Asociar clientes RIF</ListItem>,
                                            'cardsAfb': <ListItem sx={{width: "50%"}} key={i} className={liClassName(i)} onClick={cardsAfb}>Solicitud Tarjetas afb</ListItem>,
                                            'assignAfb': <ListItem sx={{width: "50%"}} key={i} className={liClassName(i)} onClick={assignAfb}>Asociar colaborador afb</ListItem>,
                                            'companiesCards': <ListItem sx={{width: "50%"}} key={i} className={liClassName(i)} onClick={findCardsCompany}>Tarjetas empresas afb</ListItem>,
                                            'companiesClients': <ListItem sx={{width: "50%"}} key={i} className={liClassName(i)} onClick={contactList}>Contactos afb</ListItem>,
                                            'createAfbCustomer': <ListItem sx={{width: "50%"}} key={i} className={liClassName(i)} onClick={createAfbCustomer}>Crear cuenta nueva afb</ListItem>,
                                            'createAfbSpace': <ListItem sx={{width: "50%"}} key={i} className={liClassName(i)} onClick={createAfbSpace}>Alta spaces adicionales afb</ListItem>,
                                            'alboCard': <ListItem sx={{width: "50%"}} key={i} className={liClassName(i)} onClick={alboCard}>Solicitud de tarjetas aBB</ListItem>,
                                            'alboCardCIH': <ListItem sx={{width: "50%"}} key={i} className={liClassName(i)} onClick={alboCardCIH}>Solicitud de tarjetas card in hand</ListItem>,
                                            'tutukaOperationManual': <ListItem sx={{width: "50%"}} key={i} className={liClassName(i)} onClick={tutukaOperationManual}>Operación manual tutuka</ListItem>,
                                            'cLevelReport': <ListItem sx={{width: "50%"}} key={i} className={liClassName(i)} onClick={cLevelReport}>Reporte validaciones pendientes</ListItem>,
                                            'pld': <ListItem sx={{width: "50%"}} key={i} className={liClassName(i)} onClick={openModalPld}>PLD</ListItem>,
                                            'featureCustomerGet': <ListItem sx={{width: "50%"}} key={i} className={liClassName(i)} onClick={featureCustomerGet}>Beneficios</ListItem>,
                                            'singleCustomerView': <ListItem sx={{width: "50%"}} key={i} className={liClassName(i)} onClick={singleCustomerView}>Vista Única del Cliente</ListItem>,
                                            'afbPreloadWorkers': <ListItem sx={{width: "50%"}} key={i} className={liClassName(i)} onClick={afbPreloadWorkers}>Preactivar workers</ListItem>,
                                            'customerHistoryGet': <ListItem sx={{width: "50%"}} key={i} className={liClassName(i)} onClick={customerHistoryGet}>Consultar eventos históricos</ListItem>
                                        }[menuItem]
                                    })
                                }
                                </Box>
                            </Card>
                        </Grid>
                        }
                        </Grid>
                </Grid>
               </Grid>
              
                <Box className='container' py={"2rem"} mt={"70px"} onClick={() => menu && showMainMenu()}>
                    <Components.Widgets
                        next={next}
                        updateNext={updateNext}
                        widgets={widgets}
                        changeLoader={props.changeLoader}
                        changeWidgets={changeWidgets}
                        pos={props.pos}
                        changeOpenModal={props.changeOpenModal}
                        openModal={props.openModal}
                        contentModal={props.contentModal}
                        changeContentModal={props.changeContentModal}
                        changeAlert={props.changeAlert}
                        valueSearch={valueSearch}
                        clase={props.loader ? `wrapper ${classes.blur}` : ''}
                        catalogs={catalogs}
                        makeOp={makeOp}
                        updateValueSearch={updateValueSearch}
                        update={props.update}
                        changeUpdate={props.changeUpdate}
                    />
                </Box>
            </ThemeProvider>
        </ContentStyle>
        </>
    )
}

export default Content;